import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

/**
 * Custom preset
 * This preset is used to customize the theme of the application.
 * To see Colors palette go to: https://v19.primeng.org/theming#colors
 */
const MAKO_COLOR = '#FF9300';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{amber.50}',
      100: '{amber.100}',
      200: '{amber.200}',
      300: '{amber.300}',
      400: '{amber.400}',
      500: MAKO_COLOR,
      600: '{amber.600}',
      700: '{amber.700}',
      800: '{amber.800}',
      900: '{amber.900}',
      950: '{amber.950}'
    },
  }
});

export default MyPreset;
